import styled from "styled-components";
import { palette } from "styled-theme";
import { Paragraph } from "@components/paragraph";

const Wrapper = styled.div`
  .paragraph-wrapper {
    padding: 12px 0;
  }
  
  ${Paragraph} {
    padding: 20px 30px;
    text-align: center;
    background: ${palette("bankStatementsPrompt", 0)};
  }
`;

export default Wrapper;
